<template>
  <div class="mall-nav-wrap mall-nav-wrap--simple">
    <FixedRightBar v-if="!isErpBuySite" />

    <!-- 内联关键布局样式，避免首屏样式未就绪时出现错乱/换行 -->
    <div class="simple-bar"   :style="{
          display: 'flex',
          alignItems: 'center',
          flexWrap: 'nowrap',
          gap: '16px',
          padding: '10px 0',
          minHeight: '64px'
        }">
      <a v-if="!isErpBuySite" class="simple-logo" :href="`/`">
        <el-image
          :style="logoStyle"
          class="logo-item"
          :src="config.imgURL"
          :fit="config.fit"
          referrerpolicy="no-referrer"
        />
      </a>

      <div class="simple-menu" v-if="!isErpBuySite" :style="simpleMenuInlineStyle">
        <div class="navigation-item" v-for="(item, index) in normalizedNavigationList" :key="index">
          <a
            v-if="item.linkUrl === '/'"
            :class="{
              'navigation-item-title': true,
              'navigation-item-title-active': actionIndex === index,
              ['navigation-item-title-' + index]: true,
            }"
            :style="{
              fontSize: ((config.textConfigs && config.textConfigs.fontSize) || 14) + 'px',
              fontWeight: (config.textConfigs && config.textConfigs.fontWeight) || 'normal',
              color:
                actionIndex === index
                  ? (config.textConfigs && config.textConfigs.fontActionColor) || '#111'
                  : (config.textConfigs && config.textConfigs.fontColor) || '#333',
            }"
            href="/"
          >
            {{ getLocaleText(item.title) }}
          </a>
          <NuxtLink
            v-else
            :class="{
              'navigation-item-title': true,
              'navigation-item-title-active': actionIndex === index,
              ['navigation-item-title-' + index]: true,
            }"
            :style="{
              fontSize: ((config.textConfigs && config.textConfigs.fontSize) || 14) + 'px',
              fontWeight: (config.textConfigs && config.textConfigs.fontWeight) || 'normal',
              color:
                actionIndex === index
                  ? (config.textConfigs && config.textConfigs.fontActionColor) || '#111'
                  : (config.textConfigs && config.textConfigs.fontColor) || '#333',
            }"
            :to="item.linkUrl"
            :target="getJumpType(item, true)"
          >
            {{ getLocaleText(item.title) }}
          </NuxtLink>
        </div>
      </div>

      <div class="simple-right" v-if="!isErpBuySite" :style="simpleRightInlineStyle">
        <LocaleCurrencyChange />
        <div class="user-info-wrap">
          <el-avatar :size="40" :src="mallUserInfo.avatarUrl || '/imgs/base-user.png'" />
          <div class="user-info-box" v-if="mallUserInfo.id">
            <NuxtLink class="user-link user-name" :to="userCenterHomePath">{{ mallUserInfo.realName }}</NuxtLink>
            <NuxtLink @click="logout" class="user-link ml-5px cursor-pointer">
              {{ $t("actions.quit") }}
            </NuxtLink>
          </div>
          <div class="user-info-box" v-else>
            <NuxtLink class="user-link" :to="userCenterRegisterPath">{{ $t("actions.newUser") }}</NuxtLink>/
            <NuxtLink :to="userCenterLoginPath" class="user-link">{{ $t("actions.login") }}</NuxtLink>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import FixedRightBar from "./FixedRightBar.vue";
import LocaleCurrencyChange from "./LocaleCurrencyChange.vue";
import { $t } from "~/utils/index.js";
import { legacyPathToUserCenterPath } from "~/user-center/routes";

const props = defineProps({
  config: { type: Object, default: () => ({}) },
  isErpBuySite: { type: Boolean, default: false },
  showNavigationList: { type: Array, default: () => [] },
  actionIndex: { type: Number, default: 0 },
  mallUserInfo: { type: Object, default: () => ({}) },
  logout: { type: Function, required: true },
  getLocaleText: { type: Function, required: true },
  getJumpType: { type: Function, required: true },
});
const userCenterHomePath = legacyPathToUserCenterPath("/mall/home");
const userCenterLoginPath = legacyPathToUserCenterPath("/login");
const userCenterRegisterPath = legacyPathToUserCenterPath("/login?reg=1");
const normalizedNavigationList = computed(() => {
  return (props.showNavigationList || []).map(item => ({
    ...item,
    linkUrl: legacyPathToUserCenterPath(String(item?.linkUrl || "")),
  }));
});

const logoStyle = computed(() => {
  const w = Number(props.config?.imgWidth) || 160;
  const h = Number(props.config?.imgHeight) || 44;
  return {
    width: `${w}px`,
    height: `${h}px`,
    minWidth: `${w}px`,
    minHeight: `${h}px`,
  };
});

// 这些是首屏“兜底”的关键布局样式：即使 scoped CSS 还没挂上，也能保持一行布局
 

const simpleMenuInlineStyle =   {
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  flex: "1 1 auto",
  minWidth: 0,
  overflowX: "auto",
  overflowY: "hidden",
  whiteSpace: "nowrap",
};

const simpleRightInlineStyle =   {
  display: "flex",
  alignItems: "center",
  flex: "0 0 auto",
  flexWrap: "nowrap",
  whiteSpace: "nowrap",
};
</script>

<style scoped lang="less">
.mall-nav-wrap--simple {
  width: 100%;
  background-color: #fff;
 
}

.simple-bar {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  gap: 16px;
  padding: 10px 0;
  min-height: 64px;
}

.simple-logo {
  display: inline-flex;
  align-items: center;
  flex: 0 0 auto;
}

.simple-menu {
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  overflow-x: auto;
  overflow-y: hidden;
  gap: 8px;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  .navigation-item {
    display: flex;
    align-items: center;
  }
  .navigation-item-title {
    display: inline-flex;
    align-items: center;
    height: 40px;
    padding: 0 12px;
    border-radius: 20px;
    text-decoration: none;
    transition: background-color 0.15s ease, color 0.15s ease;
    &:hover {
      background-color: #f6f6f6;
    }
  }
  .navigation-item-title-active {
    font-weight: 600;
    background-color: #f2f2f2;
  }
}

.simple-right {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  white-space: nowrap;
}

.user-info-wrap {
  display: flex;
  align-items: center;
  min-width: 0;
  .user-info-box {
    margin-left: 10px;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    min-width: 0;
    .user-link {
      font-size: 14px;
      color: #333;
      text-decoration: none;
      font-weight: 400;
      display: inline-block;
      white-space: nowrap;
      &:hover {
        text-decoration: underline;
      }
    }
    .user-name {
      max-width: 140px;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}

.logo-item {
  cursor: pointer;
}
</style>
